import React from 'react';
import { Collapse } from 'antd';
import { InfoCircleOutlined, ExclamationCircleOutlined, CarOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

const ParentInformation = ({ campDetails, getHtml, getFacility }) => {
    
    // Custom header component with increased font size (1.1rem)
    const customHeader = (text, icon, color = "#111827") => (
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '12px', 
            fontWeight: 700, 
            color: color,
            fontSize: '1.1rem' 
        }}>
            {icon}
            <span>{text}</span>
        </div>
    );

    // Style object for the inner content text
    const contentTextStyle = {
        fontSize: '1.05rem', // Increased font size for internal text
        lineHeight: '1.6',
        color: '#4b5563'
    };

    return (
        <div className="parent_info_section mt-5" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div className="text-center mb-4">
                <h2 style={{ fontWeight: 800, color: '#2D2D2D' }}>Parent Information</h2>
                <p style={{ color: '#666' }}>What you need to know before the program starts</p>
            </div>

            <Collapse
                accordion
                expandIconPosition="end"
                ghost={false}
                style={{ background: 'transparent', border: 'none', display: 'flex', flexDirection: 'column', gap: '16px' }}
            >
                {/* 1. Instructions & Logistics */}
                {campDetails.programInstruction && (
                    <Panel 
                        header={customHeader("Instructions & Logistics", <InfoCircleOutlined style={{ color: '#22c55e', fontSize: '20px' }} />)} 
                        key="1"
                        className="custom-panel"
                    >
                        <div className="content-inner ps-4" style={contentTextStyle}>
                            {getHtml(campDetails.programInstruction)}
                        </div>
                    </Panel>
                )}

                {/* 2. Important Notes (Red Styled) */}
                {campDetails.impNotes && (
                    <Panel 
                        header={customHeader("Important Notes", <ExclamationCircleOutlined style={{ color: '#991b1b', fontSize: '20px' }} />, "#991b1b")} 
                        key="2"
                        className="important-notes-panel"
                    >
                        <div className="content-inner ps-4" style={contentTextStyle}>
                            {getHtml(campDetails.impNotes)}
                        </div>
                    </Panel>
                )}

                {/* 3. Equipment & Facility */}
                {(campDetails.equipment || campDetails.facility) && (
                    <Panel 
                        header={customHeader("Equipment Needed & Facility Type", <CarOutlined style={{ color: '#166534', fontSize: '20px' }} />)} 
                        key="3"
                        className="custom-panel"
                    >
                        <div className="content-inner ps-4" style={contentTextStyle}>
                            {campDetails.equipment && (
                                <div className="mb-3">
                                    <h6 className="fw-bold" style={{ fontSize: '1.1rem' }}>Equipment Needed:</h6>
                                    <p>{campDetails.equipment}</p>
                                </div>
                            )}
                            {campDetails.facility && (
                                <div>
                                    <h6 className="fw-bold" style={{ fontSize: '1.1rem' }}>Facility:</h6>
                                    <p>{getFacility(campDetails.facility)}</p>
                                </div>
                            )}
                        </div>
                    </Panel>
                )}
            </Collapse>
        </div>
    );
};

export default ParentInformation;